import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Loader from '../ui/Loader';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.codeTextInput.value);
  }

  render() {
    let isDisabled = false;
    let loginButtonText = 'Login';
    if (this.props.isLoading) {
      isDisabled = true;
      loginButtonText = <Loader />;
    }

    return (
      <form className="form" onSubmit={this.onSubmit}>
        <fieldset disabled={isDisabled}>
          <input
            type="text"
            className="form__field"
            ref={(ref) => { this.codeTextInput = ref; }}
            placeholder="e.g 123 456"
          />
          <div className="form login__register-info">
            <FormattedMessage id="general.loginCode" />
          </div>
          <button className="btn btn-primary" type="submit">{loginButtonText}</button>
        </fieldset>
      </form>
    );
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default injectIntl(LoginForm);
